export const ru = {
    'interest-type-all': 'за любой период',
    'interest-type-long-term': 'долгосрочные',
    'interest-type-short-term': 'краткосрочные',
    interests: 'Интересы'
};
